import { Component, OnInit, ViewChild } from '@angular/core';
import { CountryService } from '../../../../../services/country.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Country, ICountry } from '../../../../../models/country.model';
import { Router } from '@angular/router';
import { Validation } from '../../../error/error-messages/validator-messages';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss']
})
export class CountryComponent implements OnInit {

  // @ts-ignore
  country: ICountry[] = [];
  // @ts-ignore
  currentCountry: ICountry = [];

  page = 1;
  perPage = 10;
  search: any;
  countryForm: FormGroup;
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  @ViewChild('closebutton') closebutton;

  constructor(private fb: FormBuilder, private countryService: CountryService ,
              private router :Router, private formB : FormBuilder) { }

  ngOnInit(): void {
    this.loadCountry();
    this.countryForm = this.formB.group({
      'iso' : ["" , [Validation.cityValidator("Le nom",3,20)]],
      'name' : ["" , [Validation.stringValidator("L\'iso",2,3)]]
    });
  }

  onCountryFormSubmit(){
    // console.log(this.countryForm.value);
    // Récuperer les valeurs
    const country: Country = this.countryForm.value;
    // appel sur service et la méthode d'enregistrement
    this.countryService.saveCountry(country).subscribe(rs => {
      // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le pays a été ajouté avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.close();
      this.loadCountry();
      this.reloadComponent();
    }, error => {
     // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.error.errorMessage,
        showConfirmButton: false,
        timer: 1500
      });
    });
  }
  isTrueName = false;
  getIfIsExistedCountry(countryName : any): boolean{
    let testName = countryName.target.value;
    let testbool = true;
    this.country.forEach(element =>{
      if(testbool){
        if(element.iso){
          if(element.iso.toUpperCase() === testName.toUpperCase()){
            testbool = false;
            this.isTrueName = true;
          }else{
            this.isTrueName = false;
          }
        }
      }
    });
    return this.isTrueName;
  }

  getIfIsExistedCountry1(countryName : any): boolean{
    let testName = countryName.target.value;
    let testbool = true;
    this.country.forEach(element =>{
      if(testbool){
        if(element.iso){
          if((element.iso.toUpperCase() === testName.toUpperCase()) && element.iso.toUpperCase() != this.currentCountry?.iso.toUpperCase()){
            testbool = false;
            this.isTrueName = true;
          }else{
            this.isTrueName = false;
          }
        }
      }
    });
    return this.isTrueName;
  }

  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  get f1() { return this.editCountryForm.controls; }

  editCountryForm = this.fb.group({
    iso: new FormControl('', [Validation.stringValidator("L\'iso",2,3)]),
    name: new FormControl('', [Validation.cityValidator("Le nom",3,20)]),
  });

  onEditCountry(id: any) {
    this.isTrueName = false;
    this.countryService.getidCountry(id).subscribe(rs => {
      this.currentCountry = rs;
      this.editCountryForm = this.fb.group({
        iso: new FormControl(this.currentCountry.name, [ Validation.stringValidator("L\'iso",2,3)]),
        name: new FormControl(this.currentCountry.iso, [ Validation.cityValidator("Le nom",3,20)]),
      });
    });
  }

  onEditCountryFormSubmit() {
    // console.log(this.editCountryForm.value);
    const country: Country = this.editCountryForm.value;
    this.currentCountry.name = country.iso;
    this.currentCountry.iso = country.name;
    // console.log(this.currentCountry);
    this.countryService.updateCountry(this.currentCountry).subscribe(rs => {
     // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le pays a été modifiée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.close();
      this.loadCountry();
      this.reloadComponent();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.error.errorMessage,
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  loadCountry = () => {
    this.countryService.getCountries().subscribe(data => {
      this.country = data;
    }, (err) => {
      // console.log('-----> err', err);
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    //console.log(this.perPage);
  }

  searchFilter($event: KeyboardEvent) {
    // console.log(this.search);
    this.countryService.getCountries()
      .subscribe(data => {
        this.country = data;
        this.country = this.country.filter(value =>
        value.iso.toUpperCase().includes(this.search.toUpperCase())
        || value.name?.includes(this.search.toUpperCase()));
    }, (err) => {
      // console.log('-----> err', err);
    });
  }

  verified(tab:any,value:any){
    // Vérifie si la valeur existe dans le tableau
    if(tab.indexOf(value) !== -1){
      // alert("La valeur existe!")
      return true
    } else{
      // alert("La valeur n'existe pas!")
      return false
    }
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.country.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.country.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.country.sort((a, b) => a.iso > b.iso ? 1 : a.iso < b.iso ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.country.sort((a, b) => a.iso < b.iso ? 1 : a.iso > b.iso ? -1 : 0)
      this.sorted2 = false;
    }
  }

  get iso(){
    return this.countryForm.get('iso');
  }
  get name(){
    return this.countryForm.get('name');
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  delete(id: number) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer ce pays ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.countryService.deleteCountry(id).subscribe(rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Le pays a été supprimé avec succés"',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadCountry();
          }, error => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 2500
            });
          }
        );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',
        });
      }
    });
  }

  isoequalstoname = false;
  verifyISOAndCountryName(){
    if(this.countryForm.controls['name'].value != ""){
      if(this.countryForm.controls['iso'].value==this.countryForm.controls['name'].value){
        this.isoequalstoname = true;
      }else{
        this.isoequalstoname = false;
      }
    }else{
      this.isoequalstoname = false;
    }

    return this.countryForm.controls['iso'].value!=this.countryForm.controls['name'].value;
  }

  isoequalstoname1 = false;
  verifyISOAndCountryName1(){
    if(this.editCountryForm.controls['name'].value != ""){
      if(this.editCountryForm.controls['iso'].value==this.editCountryForm.controls['name'].value){
        this.isoequalstoname1 = true;
      }else{
        this.isoequalstoname1 = false;
      }
    }else{
      this.isoequalstoname1 = false;
    }

    return this.editCountryForm.controls['iso'].value!=this.editCountryForm.controls['name'].value;
  }

}
